// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bucket-preview{color:var(--tertiary-text-color);font-size:12px;margin-left:2px;padding:16px}.toggle-el{background:var(--secondary-background-color);display:block;padding-right:112px}.title{font-size:16px;font-weight:700}.remaining-values{color:var(--secondary-text-color);font-size:12px;font-weight:700;margin-left:22px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
